"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var findClosestElementAncestor_1 = require("../utils/findClosestElementAncestor");
var getSelectedBlockElementsInRegion_1 = require("../region/getSelectedBlockElementsInRegion");
var isNodeInRegion_1 = require("../region/isNodeInRegion");
var shouldSkipNode_1 = require("../utils/shouldSkipNode");
var VList_1 = require("./VList");
var getLeafSibling_1 = require("../utils/getLeafSibling");
var getListTypeFromNode_1 = require("./getListTypeFromNode");
var ListSelector = 'ol,ul';
/**
 * @internal
 * @param region The region to get VList from
 * @param includeSiblingLists True to also try get lists before and after the selection and merge them together,
 * false to only include the list for the selected blocks
 * @param startNode (Optional) When specified, try get VList which will contain this node.
 * If not specified, get VList from selection of this region
 */
function createVListFromRegion(region, includeSiblingLists, startNode) {
    if (!region) {
        return null;
    }
    var nodes = [];
    if (startNode) {
        var list = getRootListNode(region, startNode);
        if (list) {
            nodes.push(list);
        }
    }
    else {
        var blocks = getSelectedBlockElementsInRegion_1.default(region);
        blocks.forEach(function (block) {
            var list = getRootListNode(region, block.getStartNode());
            if (list) {
                if (nodes[nodes.length - 1] != list) {
                    nodes.push(list);
                }
            }
            else {
                nodes.push(block.collapseToSingleElement());
            }
        });
        if (includeSiblingLists) {
            tryIncludeSiblingNode(region, nodes, false /*isNext*/);
            tryIncludeSiblingNode(region, nodes, true /*isNext*/);
        }
        nodes = nodes.filter(function (node) { return !shouldSkipNode_1.default(node, true /*ignoreSpace*/); });
    }
    var vList = null;
    if (nodes.length > 0) {
        var firstNode = nodes.shift();
        vList = getListTypeFromNode_1.isListElement(firstNode)
            ? new VList_1.default(firstNode)
            : createVListFromItemNode(firstNode);
        nodes.forEach(function (node) {
            if (getListTypeFromNode_1.isListElement(node)) {
                vList.mergeVList(new VList_1.default(node));
            }
            else {
                vList.appendItem(node, 0 /* None */);
            }
        });
    }
    return vList;
}
exports.default = createVListFromRegion;
function tryIncludeSiblingNode(region, nodes, isNext) {
    var node = nodes[isNext ? nodes.length - 1 : 0];
    node = getLeafSibling_1.getLeafSibling(region.rootNode, node, isNext, region.skipTags, true /*ignoreSpace*/);
    node = getRootListNode(region, node);
    if (isNodeInRegion_1.default(region, node) && getListTypeFromNode_1.isListElement(node)) {
        if (isNext) {
            nodes.push(node);
        }
        else {
            nodes.unshift(node);
        }
    }
}
function getRootListNode(region, node) {
    var list = findClosestElementAncestor_1.default(node, region.rootNode, ListSelector);
    if (list) {
        var ancestor = void 0;
        while ((ancestor = findClosestElementAncestor_1.default(list.parentNode, region.rootNode, ListSelector))) {
            list = ancestor;
        }
    }
    return list;
}
function createVListFromItemNode(node) {
    var _a;
    // Create a temporary OL root element for this list.
    var listNode = node.ownerDocument.createElement('ol'); // Either OL or UL is ok here
    (_a = node.parentNode) === null || _a === void 0 ? void 0 : _a.insertBefore(listNode, node);
    // Create the VList and append items
    var vList = new VList_1.default(listNode);
    vList.appendItem(node, 0 /* None */);
    return vList;
}
//# sourceMappingURL=createVListFromRegion.js.map